<i18n>
{
  "fr": {
    "business-list-text": "Liste des entreprises",
    "business-add-text": "Ajouter une entreprise",
    "business-type-mining-text": "Entreprise d'exploration minière",
    "business-type-provider-text": "Fournisseur de services"
  },
  "en": {
    "business-list-text": "List of Companies",
    "business-add-text": "Add a company",
    "business-type-mining-text": "Mineral exploration company",
    "business-type-provider-text": "Service provider"
  }
}
</i18n>

<template>
  <div>
    <div
      class="level"
      :class="{
        'mb-24px': $media.mobile,
        'mb-32px': $media.tablet
      }"
    >
      <div class="level-left">
        <h1 class="title is-2 has-text-weight-bold">
          {{ $t('business-list-text') }}
        </h1>
      </div>
      <div class="level-right">
        <b-button type="is-link" icon-left="plus-circle" @click="addBusiness">
          {{ $t('business-add-text') }}
        </b-button>
      </div>
    </div>
    <b-tabs v-model="activeTab">
      <b-tab-item :class="{ 'pt-12px': $media.mobile }" :label="$t('business-type-mining-text')">
        <div class="card">
          <business-list-table :category="$consts.enums.BUSINESS_CATEGORY_EEM" />
        </div>
      </b-tab-item>
      <b-tab-item :class="{ 'pt-12px': $media.mobile }" :label="$t('business-type-provider-text')">
        <div class="card">
          <business-list-table :category="$consts.enums.BUSINESS_CATEGORY_PROVIDER" />
        </div>
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import Breadcrumbs from '@/mixins/breadcrumbs'

import BusinessListTable from '@/components/businesses/business-list-table'
import { URL_BUSINESS_ADD } from '@/consts/urls'

export default {
  mixins: [Breadcrumbs],
  components: { BusinessListTable },
  data() {
    return {
      activeTab: 0
    }
  },
  methods: {
    addBusiness: function () {
      this.$router.push({ name: URL_BUSINESS_ADD })
    }
  },
  computed: {
    breadcrumbs() {
      return [
        {
          label: this.$t('business-list-text')
        }
      ]
    }
  }
}
</script>
